import { render } from "./MenuComponent.vue?vue&type=template&id=01810c5e&scoped=true&ts=true"
import script from "./MenuComponent.vue?vue&type=script&lang=ts"
export * from "./MenuComponent.vue?vue&type=script&lang=ts"

import "./MenuComponent.vue?vue&type=style&index=0&id=01810c5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01810c5e"]])

export default __exports__